import Security from "components/Settings/SecurityTab/index";
import React from "react";

function EmployeeSecurity() {
  return (
    <>
      {" "}
      <Security />
    </>
  );
}

export default EmployeeSecurity;
